import Link from 'next/link';
import { Text } from '@pairy/pds-react';
import { useMediaQuery } from 'react-responsive';

import MainLayout from '../Layouts/Main';

import Form from './Form';
import * as Styled from './index.styles';
import Links from './PolicyLinks';

const SignUp = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return (
    <MainLayout isMobile={isMobile}>
      <Styled.Wrapper>
        <Styled.Title as="h1" variant="3xl-semibold" textAlign="center">
          <Text variant="xl-medium" textAlign="center">
            간단한 정보 입력 후,
          </Text>
          <br />
          고객 마음 알아보기를 시작합니다!
        </Styled.Title>
        <Text as="p" color="zinc_400" variant="md-regular" textAlign="center">
          입력하신 정보는
          <br />
          회원가입 완료 후 안전하게 저장됩니다.
        </Text>
        <Form />
        <Link href="/login">
          <a>
            <Text
              as="p"
              variant="md-bold"
              color="skyblue_400"
              textAlign="center"
            >
              이미 가입하셨나요? 로그인하기
            </Text>
          </a>
        </Link>
        <Links />
      </Styled.Wrapper>
    </MainLayout>
  );
};

export default SignUp;
